import React, { useCallback } from 'react';

import { Alert, Button, Flex, Icon, Text } from '~/components/blocks';

type Props = {
  isOpen: () => void;
};

export const MaterialsInfo: React.FC<Props> = (props) => {
  const { isOpen } = props;

  const handleOpenModal = useCallback(() => {
    isOpen();
  }, [isOpen]);

  return (
    <Alert status="info" contentWidth="max-content">
      <Flex alignItems="center">
        貴局専用資材をご用意しています。 印刷して各種機能のご案内にご活用ください。
        <Button onClick={handleOpenModal}>
          <Icon icon="print" size="m" />
          <Text>患者様向け資材</Text>
        </Button>
      </Flex>
    </Alert>
  );
};
